import logo from './logo.svg';
import './App.css';
import BaseLayout from './pages/layout/base';

function App() {
  return (
    <div className="app h-100" >
      <BaseLayout />
    </div>
  );
}

export default App;
